// Generated TypeScript file - DO NOT EDIT
// Last updated: 2026-02-17T12:56:27.039Z
import { SuperTooltipTemplate } from './types';

export type SuperTooltipTemplateId =
  | 'accomplishments'
  | 'profile-avatar-image'
  | 'checklist-build-workouts-otp'
  | 'checklist-build-workouts-subscription'
  | 'checklist-checkout-link'
  | 'checklist-consumer-flows'
  | 'checklist-create-otp'
  | 'checklist-create-pdf'
  | 'checklist-film-edit'
  | 'checklist-go-live-not-ready'
  | 'checklist-go-live'
  | 'checklist-intro-video'
  | 'checklist-join-community'
  | 'checklist-mobile-app'
  | 'checklist-plan-subscription'
  | 'checklist-setup-landing-page'
  | 'checklist-setup-price'
  | 'checklist-setup-profile'
  | 'checklist-setup-stripe'
  | 'checklist-setup-subscription'
  | 'checklist-shotlist'
  | 'checklist-social-media'
  | 'checklist-strategy-overview'
  | 'checklist-update-bio'
  | 'checklist-upload-library'
  | 'checklist-write-program'
  | 'cover-image'
  | 'extras-details'
  | 'extras-links'
  | 'extras-pdf'
  | 'extras-slides'
  | 'extras-video'
  | 'intro-video'
  | 'offers-banner'
  | 'profile-banner'
  | 'profile-title'
  | 'profile-story';

export const templatesByID: Record<string, SuperTooltipTemplate[]> = {
  accomplishments: [
    {
      title: 'Accomplishments',
      content:
        'Highlight any certifications, awards, or experiences that show your expertise and credibility as a fitness professional.\n\nExamples used by our successful creators:',
      tips: [
        'Think about what makes you qualified to lead others — whether it’s formal training, special achievements, or years of experience',
        'This is your chance to show users why they can trust and learn from you!',
      ],
      tags: [
        'Certified Personal Trainer',
        'Certified Nutritionist',
        'Cookbook Author',
        'Former Division 1 Track & Field Athlete',
        'The Founder of Cross Projects',
        'NCCPT Certified Personal Trainer',
        "Former NPC Men's Physique Competitor",
      ],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'accomplishments',
        order: 10,
        name: 'Accomplishments',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'profile-avatar-image': [
    {
      title: 'Avatar Image',
      content: '',
      tips: [
        'Choose a clear photo of your face where you’re easy to recognize.',
        'Think good lighting, minimal distractions, and a friendly expression.',
        'This will be your profile photo, so pick something that feels like you!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Set up your profile on superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      additionalLinks: [],
      footnote: '**Read more here?**',
      layout: 'two-column',
      frontMatter: {
        templateId: 'profile-avatar-image',
        name: 'Avatar Image',
        order: 10,
      },
      type: 'single-image',
      imageUrl: 'avatar.png',
      imageAlt: 'Examples of avatars of our most successful creators',
    },
  ],
  'checklist-build-workouts-otp': [
    {
      title: 'Build your workouts',
      content:
        "Add your workouts to the program you’ve just created. Click 'edit' on your program, go to workouts tab and start adding your workouts",
      tips: [],
      tags: [],
      ctaLink: 'internal:otps',
      ctaLabel: 'Go to One-time Purchase',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-build-workouts-otp',
        order: 10,
        name: 'Build Workouts',
      },
      type: 'animated',
      videoUrl: 'web-building-workouts-otp.mp4',
    },
  ],
  'checklist-build-workouts-subscription': [
    {
      title: 'Build your workouts',
      content:
        'Now you are going to add workouts to the program that you just created.\n\nGo the workouts tab and click edit on the program you just created and start adding workouts to your program. Make sure you click publish when all workouts are in the program.',
      tips: [],
      tags: [],
      ctaLink: 'internal:subscriptions',
      ctaLabel: 'Go to Workouts',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-build-workouts-subscription',
        order: 10,
        name: 'Build Workouts',
      },
      type: 'animated',
      videoUrl: 'web-building-workouts-subscription.mp4',
    },
  ],
  'checklist-checkout-link': [
    {
      title: 'Use the right link',
      content:
        "We've got a link for you with the discount code already applied. Use this link so that your users don't even have to type in that promo code.",
      tips: [],
      tags: [],
      ctaLink: 'internal:promotions',
      ctaLabel: 'Go to Promotions',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-checkout-link',
        order: 10,
        name: 'Checkout Link',
      },
      type: 'animated',
      videoUrl: 'promotions-checkout-link.mp4',
    },
  ],
  'checklist-consumer-flows': [
    {
      title: 'Test your freebie',
      content: 'We want to make sure you understand your users checkout flow!',
      tips: [
        'Use that checkout link from your discounted offer, so you know exactly what your users will see as they check out.',
        'After checkout, you’re prompted to download the Playbook app to access your freebie.',
        'Enjoy your consumer experience',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Need help?',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/12384632-understanding-consumer-flows-on-playbook',
      readMoreLabel: 'Learn more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-consumer-flows',
        order: 10,
        name: 'Consumer Flows',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-create-otp': [
    {
      title: "Let's make an OTP",
      content:
        'A one-time purchase (OTP) is a great way to start making money today and test yourself in the market. You can build a subscription product or more expensive One-Time Purchases in the future. Keep it simple to start!',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-create-otp',
        order: 10,
        name: 'Create OTP',
      },
      type: 'video',
      videoThumbnailUrl: 'otp-strategy-thumbnail.png',
      videoUrl:
        'https://d2crdjgereq3ox.cloudfront.net/onboarding/vid/otp-strategy.mp4',
    },
  ],
  'checklist-create-pdf': [
    {
      title: 'Freebies can be simple!',
      content:
        "Don't overthink this! You can use a google doc, a template, anything! Share something of value to YOUR target audience.",
      tips: [
        'Use a PDF you already have.',
        'Make sure it speaks to what you\'ll be delivering more of! "4 Workouts to Get Started" or similar works great!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText:
        "Need help? Check out our templates for you to build with. Save your PDF when you're done",
      readMoreLink:
        'https://community.joinplaybook.com/c/resources-templates/pdf-templates-for-your-offer',
      readMoreLabel: 'Canva Templates',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-create-pdf',
        order: 10,
        name: 'Create PDF Freebie',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-film-edit': [
    {
      title: 'Film & edit',
      content:
        "It's time to film and edit! Please take some of our best practices into consideration:",
      tips: [
        '**Best practices for exercise clips:**',
        'Film vertical/portrait mode',
        'Clips must be under 60 seconds',
        'Film 3-4 reps of a movement: 14 second clips are IDEAL.',
        'Mute your exercise clips in real time',
        '**Best practices for classes:**',
        'Filmed horizontal/landscape mode',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Need more help? Check out our help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/9478207-how-to-film-great-workout-videos',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-film-edit',
        order: 10,
        name: 'Film Edit',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-go-live-not-ready': [
    {
      title: 'Can’t go live yet',
      content:
        'Going live means your app will be available to users and you’ll be able to start selling your products & offers.',
      tips: [
        'Create at least one offer',
        'Set up your profile & Stripe account',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Need help?',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11525824-how-to-launch-your-app-on-playbook',
      readMoreLabel: 'How to go live?',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-go-live-not-ready',
        order: 10,
        name: 'Go Live Not Ready',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-go-live': [
    {
      title: '🚀 Ready to Go Live ?',
      content:
        'Click that Go Live Button up above and make sure you go through the next few steps to set yourself up for a great launch',
      tips: [],
      tags: [],
      ctaLink: 'internal:go-live',
      ctaLabel: 'Go Live',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      footnote:
        'All published offers and extra content will automatically be visible on your app.\n🚨 Go Live cannot be undone',
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-go-live',
        order: 10,
        name: 'Go Live',
      },
      type: 'single-image',
      imageUrl: 'go-live.png',
      imageAlt: 'Go Live',
    },
  ],
  'checklist-intro-video': [
    {
      title: 'Welcome to Playbook!',
      content:
        "Before diving in, check out this 2-minute video to get a sense of the platform. It'll help you build faster and earn sooner.",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-intro-video',
        order: 10,
        name: 'Intro Video',
      },
      type: 'video',
      videoThumbnailUrl: 'welcome-to-playbook-thumbnail.png',
      videoUrl:
        'https://d2crdjgereq3ox.cloudfront.net/onboarding/vid/welcome-to-playbook.mp4',
    },
  ],
  'checklist-join-community': [
    {
      title: 'Join the creator community',
      content:
        'Join our Free Creator Community! The best place to keep getting help and growing with fellow creators.',
      tips: [],
      tags: [],
      ctaLink: 'internal:community',
      ctaLabel: 'Join Community',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-join-community',
        order: 10,
        name: 'Join Community',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-mobile-app': [
    {
      title: 'Grab the Creator app for iOS!',
      content:
        "Once you're up and running, you'll be able to create and edit content on-the-go. Grab our Creator App now before you forget!",
      tips: [],
      tags: [],
      ctaLink: 'https://apps.apple.com/us/app/playbook-creator/id1166632935',
      ctaLabel: 'iOS Download',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-mobile-app',
        order: 10,
        name: 'Mobile App',
      },
      type: 'single-image',
      imageUrl: 'mobile-app-qr.png',
      imageAlt: 'Cover image',
    },
  ],
  'checklist-plan-subscription': [
    {
      title: 'Plan your subscription',
      content:
        'A subscription is the best business model long term, but it requires the most work. A subscription is a future promise to your users, you need 3 key pillars:\n\n1. Community\n2. Ongoing content (new splits every week or month)\n3. A base of content (evergreen programs)\n\nPlan out (literally write this on paper 🤓) what you are going to do for these 3 pillars.',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-plan-subscription',
        order: 10,
        name: 'Plan Subscription',
      },
      type: 'video',
      videoThumbnailUrl: 'sub-strategy-thumbnail.png',
      videoUrl:
        'https://d2crdjgereq3ox.cloudfront.net/onboarding/vid/sub-strategy.mp4',
    },
  ],
  'checklist-setup-landing-page': [
    {
      title: 'Set up your landing page',
      content:
        "It's time to get ready to sell your subscription. You are going to go back to the Subscription page, click on 'Landing Page' at the top of the screen and build your landing page.",
      tips: [],
      tags: [],
      ctaLink: 'internal:subscription',
      ctaLabel: 'Go to Subscription',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-setup-landing-page',
        order: 10,
        name: 'Setup Landing Page',
      },
      type: 'animated',
      videoUrl: 'web-landing-page-edit.mp4',
    },
  ],
  'checklist-setup-price': [
    {
      title: 'Set up price & landing page',
      content: "It's time to get ready to sell your OTP.",
      tips: [
        'Go back to OTP page & edit',
        'Set your price on the "price tab"',
        'Edit your landing page on "Landing Page" tab',
      ],
      tags: [],
      ctaLink: 'internal:otps',
      ctaLabel: 'Go to One Time Purchase',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-setup-price',
        order: 10,
        name: 'Setup Price',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-setup-profile': [
    {
      title: 'Set up your profile',
      content:
        "This is where you'll take care of your Profile. There's a lot to fill in here, but we recommend filling in the basics: Name, About You, Cover and Avatar Images and Intro Video.",
      tips: [],
      tags: [],
      ctaLink: 'internal:profile',
      ctaLabel: 'Go to Profile',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-setup-profile',
        order: 10,
        name: 'Setup Profile',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-setup-stripe': [
    {
      title: 'Connect your Stripe account',
      content:
        'This will bring you to Stripe, who handles our payments. Click this to link things up and get paid!',
      tips: [],
      tags: [],
      ctaLink: 'internal:payouts',
      ctaLabel: 'Connect Stripe',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-setup-stripe',
        order: 10,
        name: 'Setup Stripe',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-setup-subscription': [
    {
      title: 'Create and price your Subscription',
      content:
        "It's time to set up your subscription and price it. Head over to the 'Subscription tab' and create your subscription. You'll enter in your price and then set up your first program.",
      tips: [],
      tags: [],
      ctaLink: 'internal:subscription',
      ctaLabel: 'Go to Subscription',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-setup-subscription',
        order: 10,
        name: 'Setup Subscription',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-shotlist': [
    {
      title: 'Create your shotlist',
      content:
        'Create your shotlist (a list of the unique exercises you are going to film)',
      tips: [
        '**Pro-tip:** you can use AI to make it easier to grab a shot list',
      ],
      tags: [],
      ctaLink: 'https://www.loom.com/share/c9a9eed47bee45a0a391b925d181272c',
      ctaLabel: 'Learn how',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-shotlist',
        order: 10,
        name: 'Shotlist',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-social-media': [
    {
      title: 'Share your link on social media',
      content:
        'Consistency is key! Post to your social media regularly to keep interest high.',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Need inspiration?',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/9478430-how-to-promote-your-business-on-instagram-stories',
      readMoreLabel: 'Learn more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-social-media',
        order: 10,
        name: 'Social Media',
      },
      type: 'single-image',
      imageUrl: 'social-media.png',
      imageAlt: 'social media',
    },
  ],
  'checklist-strategy-overview': [
    {
      title: 'Let’s make a freebie',
      content:
        "Freebies are an ideal way to test your audience and you'll build a list to re-market to!",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-strategy-overview',
        order: 10,
        name: 'Strategy Overview',
      },
      type: 'video',
      videoThumbnailUrl: 'freebie-strategy-thumbnail.png',
      videoUrl:
        'https://d2crdjgereq3ox.cloudfront.net/onboarding/vid/freebie-strategy.mp4',
    },
  ],
  'checklist-update-bio': [
    {
      title: 'Update your Link In Bio',
      content:
        "Update your Link In Bio on Instagram or anywhere else so that you're promoting your Playbook Profile and the Freebie Link everywhere possible.",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-update-bio',
        order: 10,
        name: 'Go Live Not Ready',
      },
      type: 'animated',
      videoUrl: 'web-update-bio.mp4',
    },
  ],
  'checklist-upload-library': [
    {
      title: 'Upload to your library',
      content: 'Bulk upload your clips and/or classes to the library',
      tips: [
        '**Best practices for exercise clips:**',
        'Select all clips you want to upload',
        'Trim, title, and add descriptions (most auto populate)',
        'Upload all of your exercises at once',
        '**Best practices for classes:**',
        'Larger files take more time to upload.',
        'Upload 1-2 classes at a time for efficiency',
      ],
      tags: [],
      ctaLink: 'internal:library',
      ctaLabel: 'Go to Library',
      readMoreText: 'Need more help? Check out our help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/9486421-how-to-upload-your-exercises-to-the-library-on-the-dashboard',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-upload-library',
        order: 10,
        name: 'Upload Library',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'checklist-write-program': [
    {
      title: 'Write your program',
      content: 'Make sure you have your program written down somewhere.',
      tips: [
        'Use a document or a spreadsheet, just have a plan before you really start up!',
        "We've found that 4-6 week programs do best, so plan accordingly.",
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText:
        'Need some program examples? We have templates ready for you.',
      readMoreLink:
        'https://docs.google.com/spreadsheets/d/10Maki_cQbzA1o3Z-q0w2tUuJldGL5P4JVmX8buSikGI/edit?gid=1031106436#gid=1031106436',
      readMoreLabel: 'Use Templates',
      additionalLinks: [
        {
          text: 'ChatGPT and other AI tools can be your friend, too. Check out our resource.',
          link: 'https://docs.google.com/document/d/1jHpCoNspXee_Rs8a7jsDgTcZRLwVUjd3JO4DwMhEOGc/edit?tab=t.0#heading=h.uns81t5v5jeh',
          label: 'Learn more',
        },
      ],
      layout: 'one-column',
      frontMatter: {
        templateId: 'checklist-write-program',
        order: 10,
        name: 'Write Program',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'cover-image': [
    {
      title: 'Cover image',
      content:
        'Shown in Discovery section and will be displayed when users search for trainers.',
      tips: ['Make sure it represents you well and stands out!'],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Get your profile to superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'cover-image',
        order: 10,
        name: 'Cover image',
        version: '1.0s',
        author: 'product-team',
      },
      type: 'single-image',
      imageUrl: 'cover-image-bg.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Cover Image',
      content: 'Examples of cover images of some successful creators:',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Get your profile to superstar level with',
      readMoreLink: 'https://www.joinplaybook.com/handbook',
      readMoreLabel: 'The Handbook',
      additionalLinks: [],
      footnote: '**Read more here?**',
      layout: 'two-column',
      frontMatter: {
        templateId: 'cover-image',
        order: 30,
        name: 'Next Steps',
      },
      type: 'two-image',
      imageUrls: ['cover-image-1.png', 'cover-image-2.png'],
      imageAlts: ['Cover image 1', 'Cover image 2'],
    },
  ],
  'extras-details': [
    {
      title: 'Your Extras',
      content:
        'The Extras section lets you share external resources like links, slides, educational videos or PDFs to give your audience added value beyond workouts.',
      tips: [
        'Feature affiliate links, playlists, eBooks, or any other content you want to share.',
        'Rename and customize your Extras tab to fit your brand.',
        'Make everything easily accessible to your subscribers and customers.',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      layout: 'two-column',
      frontMatter: {
        templateId: 'extras-details',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'extras-details-cover.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-links': [
    {
      title: 'What are Links?',
      content:
        'Add and manage external links for your Extras tab. Use them to share promotions, resources, or LinkTree-style pages with your subscribers.',
      tips: [
        'Add a custom Banner Image for your link; if none is uploaded, the link title will be shown instead',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-slides-and-pdfs',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-links',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'link-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-pdf': [
    {
      title: 'What are PDFs?',
      content:
        'Share in-depth materials your audience can read and save for later—like guides, checklists, or full programs. PDFs must be created outside of Playbook before you upload them here.',
      tips: [
        'Add a custom Banner Image for your PDF; if none is uploaded, the PDF title will be shown instead',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-pdf',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'pdf-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-slides': [
    {
      title: 'What are Slides?',
      content:
        'Upload sequenced images to showcase your content as if it were a presentation',
      tips: [
        'Add a custom Banner Image for your slide; if none is uploaded, the slide title will be shown instead',
      ],
      tags: [],
      ctaLink: 'https://playbookapp.io/creators/slide-templates',
      ctaLabel: 'Go to templates',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/11794438-how-to-use-the-extras-tab-to-add-links-and-resources-to-your-channel',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-slides',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'slides-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'extras-video': [
    {
      title: 'What are Videos?',
      content:
        'Upload videos that cover topics like nutrition tips, mindset talks, overviews, or anything else your audience needs.',
      tips: [
        'Add a custom Banner Image for your video to make it stand out more',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: 'Check out our full help article',
      readMoreLink:
        'https://help.playbookapp.io/en/articles/12532288-how-to-use-the-video-template',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'extras-video',
        order: 10,
        name: 'Extras',
      },
      type: 'single-image',
      imageUrl: 'video-extras.png',
      imageAlt: 'Cover image',
    },
  ],
  'intro-video': [
    {
      title: 'Introduction Video',
      content:
        'Your intro video is extremely important since it’s the first thing a user will see when he or she downloads your app.\n\nHere’s a super simple script for your intro video:',
      tips: [
        'Hi guys, welcome to my app! I can’t wait for you to check out all of my workouts. I’ll be posting new content every week. Be sure to let me know what you think!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '​You can find other sample scripts and tips',
      readMoreLink:
        'https://www.joinplaybook.com/videos/how-to-film-an-intro-video',
      readMoreLabel: 'link:here',
      additionalLinks: [],
      footnote: '**Read more here?**',
      layout: 'two-column',
      frontMatter: {
        templateId: 'intro-video',
        order: 10,
        name: 'Cover image',
        version: '1.0s',
        author: 'product-team',
      },
      type: 'video',
      videoThumbnailUrl: 'intro-thumbnail.png',
      videoUrl:
        'https://d3l5vala1x2h4r.cloudfront.net/1705621907726_1705621902.010694-output-compressed..mp4',
    },
  ],
  'offers-banner': [
    {
      title: 'Sell Individual Programs and Extras',
      content:
        "Creating an offer allows you to put a price tag on multiple items (or a single item!) and sell them as standalone products.\n\nYou can package anything together: A PDF, a few Videos, even Workout Programs and Community access, however you'd like.",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 10,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-intro.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content:
        "You're packaging things together, consider offering them at a discount to maximize interest from your users.\n\nGet inspired with these top strategies from some of our most successful creators",
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 20,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-format.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content: '',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 30,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-discounts.png',
      imageAlt: 'Cover image',
    },
    {
      title: 'Bundle up!',
      content: '',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'offers-banner',
        order: 40,
        name: 'Offers Banner',
      },
      type: 'single-image',
      imageUrl: 'offers-theme.png',
      imageAlt: 'Cover image',
    },
  ],
  'profile-banner': [
    {
      title: 'Banner Image',
      content:
        '<img src="canva-logo.png"> We have partnered with Canva to provide you with a template that you can use to easily design your banner.',
      tips: [],
      tags: [],
      ctaLink:
        'https://www.canva.com/design/DAFvBfB0k5c/brvdLPiGdKsZEQvticaTOQ/view',
      ctaLabel: 'Go to templates',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 10,
        name: 'Profile Banner',
      },
      type: 'single-image',
      imageUrl: 'canva.png',
      imageAlt: 'Canva',
    },
    {
      title: 'Profile Banner',
      content:
        'Displayed at the top of your profile, choose an eye-catching image that reflects your personality and style.',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 20,
        name: 'Profile Banner',
      },
      type: 'single-image',
      imageUrl: 'profile-banner.png',
      imageAlt: 'Profile Banner',
    },
    {
      title: 'Profile Banner',
      content: 'Examples of profile banners of our successful creators:',
      tips: [],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-banner',
        order: 30,
        name: 'Profile Banner',
      },
      type: 'two-image',
      imageUrls: [
        'profile-banner-example-1.png',
        'profile-banner-example-2.png',
      ],
      imageAlts: ['Cover image 1', 'Cover image 2'],
    },
  ],
  'profile-title': [
    {
      title: 'Profile Title',
      content:
        'Add your title (i.e. Fitness Instructor, Bodybuilder, Yogi Guru). Feel free to get creative with it!\n\nExamples of titles used by our successful creators:',
      tips: [],
      tags: [
        'Metabolic MELT Method | Fat Loss Specialist',
        'Your Meditation Coach. Mind & Body Connection',
        'FUNctional Fitness | Nutrition',
        'Yoga and Fitness Integration for Stressfree Lifestyle',
      ],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'one-column',
      frontMatter: {
        templateId: 'profile-title',
        order: 10,
        name: 'Profile title',
      },
      type: 'basic',
      imageAlt: 'Placeholder image',
    },
  ],
  'profile-story': [
    {
      title: 'Profile Story',
      content:
        "Think about the experiences that shaped you and why you're passionate about helping others.",
      tips: [
        "Think about the experiences that shaped you and why you're passionate about helping others.",
        'Let your users know what drives you and how you’re here to support them!',
      ],
      tags: [],
      ctaLink: '',
      ctaLabel: '',
      readMoreText: '',
      readMoreLink: '#',
      readMoreLabel: 'Read more',
      additionalLinks: [],
      layout: 'two-column',
      frontMatter: {
        templateId: 'profile-story',
        order: 10,
        name: 'Profile Story',
      },
      type: 'two-image',
      imageUrls: ['story-1.png', 'story-2.png'],
      imageAlts: ['Story', 'Story'],
    },
  ],
};

export function getTemplatesByID(
  templateId: SuperTooltipTemplateId,
): SuperTooltipTemplate[] {
  return templatesByID[templateId] || [];
}

export const availableTemplateIDs: SuperTooltipTemplateId[] = [
  'accomplishments',
  'profile-avatar-image',
  'checklist-build-workouts-otp',
  'checklist-build-workouts-subscription',
  'checklist-checkout-link',
  'checklist-consumer-flows',
  'checklist-create-otp',
  'checklist-create-pdf',
  'checklist-film-edit',
  'checklist-go-live-not-ready',
  'checklist-go-live',
  'checklist-intro-video',
  'checklist-join-community',
  'checklist-mobile-app',
  'checklist-plan-subscription',
  'checklist-setup-landing-page',
  'checklist-setup-price',
  'checklist-setup-profile',
  'checklist-setup-stripe',
  'checklist-setup-subscription',
  'checklist-shotlist',
  'checklist-social-media',
  'checklist-strategy-overview',
  'checklist-update-bio',
  'checklist-upload-library',
  'checklist-write-program',
  'cover-image',
  'extras-details',
  'extras-links',
  'extras-pdf',
  'extras-slides',
  'extras-video',
  'intro-video',
  'offers-banner',
  'profile-banner',
  'profile-title',
  'profile-story',
];
